import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input, FormActions } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const passwordMinLength = validators.minLength(6);

const ChangePasswordForm = ({ error, handleSubmit, pristine, submitting, submitSucceeded, t }) => {

	return (
		<form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && <Alert bsStyle='success'>{t('FO_ChangePassword_UpdateSuccess')}</Alert>}
			<Field name='currentPassword' component={Input} type='password' horizontal required label={t('FO_ChangePassword_CurrentPassword')} icon='fa fa-lock' validate={[validators.required]} />
			<Field name='newPassword' component={Input} type='password' horizontal required label={t('FO_ChangePassword_NewPassword')} icon='fa fa-lock' validate={[validators.required, passwordMinLength]} />
			<Field name='confirmPassword' component={Input} type='password' horizontal required label={t('FO_ChangePassword_ConfirmPassword')} icon='fa fa-lock' validate={[validators.required, passwordMinLength]} />
			<Field name='token' component={Input} type='hidden' />
			<FormActions horizontal>
				<Button type='submit' disabled={pristine || submitting} bsStyle='primary' className='pull-right btn-block-xxs'>
					{t('FO_ChangePassword_Submit')} <i className='fa fa-arrow-circle-right'></i>
				</Button>
			</FormActions>
		</form>
	);
};

ChangePasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'changePassword' })(withTranslation()(ChangePasswordForm));